import template from './ChecklistModalView.html';
import controller from './ChecklistModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            title: params.title || '',
            checklistColumnHeader: params.checklistColumnHeader || '',
            descriptionColumnHeader: params.descriptionColumnHeader || '',
            items: params.items || [],
            submitButtonText: params.submitButtonText || '',
            modalSize: params.modalSize || '',
        },
    };
};
